export const removeHyphens = (text: string): string =>
  text.replace(/-/g, ' ').replace(/([0-9])\s([0-9])/, '$1-$2');
